<script lang="ts" setup>
import { WIDTH_OPTIONS, HEIGHT_OPTIONS } from '@/modules/core/dashboards/utils';

defineOptions({
    name: 'field-text'
});

const width = defineModel<number>('width');
const height = defineModel<number>('height');
</script>

<template>
    <div class="row">
        <div class="col-md-6">
            <ideo-form-group :label="$t('[[[Szerokość]]]')" required>
                <ideo-form-select v-model="width" name="width" :options="WIDTH_OPTIONS" />
            </ideo-form-group>
        </div>
        <div class="col-md-6">
            <ideo-form-group :label="$t('[[[Wysokość]]]')" required>
                <ideo-form-select v-model="height" name="height" :options="HEIGHT_OPTIONS" />
            </ideo-form-group>
        </div>
    </div>
</template>
